"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFilterSingle = void 0;
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Radio_1 = __importDefault(require("@material-ui/core/Radio"));
var RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var APText_1 = require("../../elements/APText");
var APFlex_1 = require("../../layout/APFlex");
var APFilterMenu_1 = require("./APFilterMenu");
function APFilterSingle(_a) {
    var header = _a.header, options = _a.options, onChange = _a.onChange, initialValue = _a.initialValue;
    var _b = react_1.useState(initialValue ? initialValue : options[0].value), selected = _b[0], setSelected = _b[1];
    var _c = react_1.useState(""), searchText = _c[0], setSearchText = _c[1];
    react_1.useEffect(function () {
        console.log("Calling onChange");
        onChange(selected);
    }, [selected]);
    react_1.useEffect(function () {
        if (initialValue)
            setSelected(initialValue);
    }, [initialValue]);
    var filteredOptions = options
        .filter(function (option) {
        if (searchText.length > 0) {
            return option.label.toLowerCase().includes(searchText.toLowerCase()) || option.value.toLowerCase().includes(searchText.toLowerCase());
        }
        return true;
    });
    return react_1.default.createElement(APFlex_1.APColumn, { mainAxisSize: 'max', crossAxisAlignment: 'stretch' },
        react_1.default.createElement(APFilterMenu_1.HeaderItem, { text: header }),
        options.length > 7 ? react_1.default.createElement(__1.APDebounceText, { style: { marginLeft: "12px", marginRight: "12px", marginBottom: "6px", }, onChanged: function (v) { setSearchText(v); } }) : undefined,
        react_1.default.createElement(__1.APExpanded, null,
            react_1.default.createElement(RadioGroup_1.default, { value: selected, onChange: function (e, v) {
                    setSelected(v);
                    e.stopPropagation();
                    e.preventDefault();
                } },
                react_1.default.createElement(__1.APExpanded, null,
                    react_1.default.createElement(__1.APVirtualList, { itemCount: filteredOptions.length, itemHeight: 36 }, function (_a) {
                        var index = _a.index;
                        var option = filteredOptions[index];
                        return react_1.default.createElement(FormControlLabel_1.default, { style: { padding: "0 12px" }, key: index, value: option.value, control: react_1.default.createElement(Radio_1.default, { color: 'primary', size: 'small' }), label: react_1.default.createElement(APText_1.APText, { variant: "normal", style: { fontWeight: 500, color: selected === option.value ? "#111" : "#555" } }, option.label) });
                    })))));
}
exports.APFilterSingle = APFilterSingle;
